/* eslint-disable no-extend-native */
(function () {
  if (!Array.prototype.flat) {
    Object.defineProperty(Array.prototype, 'flat', {
      value: function (depth) {
        let res = []
        let depthArg = depth || 1
        let depthNum = 0
        let flatMap = (arr) => {
          arr.map((element, index, array) => {
            if (Object.prototype.toString.call(element).slice(8, -1) === 'Array') {
              if (depthNum < depthArg) {
                depthNum++
                flatMap(element)
              } else {
                res.push(element)
              }
            } else {
              res.push(element)
              if (index === array.length - 1) depthNum = 0
            }
          })
        }
        flatMap(this)
        return res
      }
    })
  }
}())
